import { reducerWithInitialState } from 'typescript-fsa-reducers';
import { toggleViewEditMode } from './_helpers/toggleViewEditMode';
import { DetailsSidebarAction } from './detailsSidebar.action';
import { detailsSidebarInitialState } from './detailsSidebar.constant';
import { SidebarOpenMode, IDetailsSidebarStore } from './detailsSidebar.interface';

export const detailsSidebarReducer = reducerWithInitialState(detailsSidebarInitialState)
  .case(DetailsSidebarAction.setState, (state, payload): IDetailsSidebarStore => {
    return {
      ...state,
      mode: payload.mode,
      id: payload.id,
      type: payload.type,
    };
  })
  .case(DetailsSidebarAction.openDefault, (state, payload): IDetailsSidebarStore => {
    return {
      ...state,
      mode: SidebarOpenMode.View,
      id: payload.id,
    };
  })
  .case(DetailsSidebarAction.toggleEdit, (state): IDetailsSidebarStore => {
    if (
      (state.mode === SidebarOpenMode.View || state.mode === SidebarOpenMode.Edit)
      && state.id
    ) {
      return {
        ...state,
        mode: toggleViewEditMode(state.mode),
      };
    }

    return state;
  })
  .cases([
    DetailsSidebarAction.destroy,
  ], () => {
    return detailsSidebarInitialState;
  });
